"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStepTitleWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../helpers");
const StackView_1 = require("../../../StackView");
exports.StyledStepTitleWrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    flex: 1;
    outline: none;
    padding: 19px ${helpers_1.SPACING_S} ${({ isHighlightable }) => (isHighlightable ? helpers_1.SPACING_L : helpers_1.SPACING_S)};

    &:hover {
        background-color: ${({ isHighlightable, theme }) => isHighlightable ? theme.colorHighlightLight : 'transparent'};
        cursor: ${({ isHighlightable }) => (isHighlightable ? 'pointer' : '')};
    }

    &:focus {
        background-color: ${({ isHighlightable, theme }) => isHighlightable ? theme.colorHighlightDark : 'transparent'};
        cursor: ${({ isHighlightable }) => (isHighlightable ? 'pointer' : '')};
    }
`;
//# sourceMappingURL=StepTitleWrapper.styles.js.map